<template>
  <v-app-bar app flat color="white" class="fufugrey2--text">
    <v-layout align-center>
      <v-flex xs2>
        <v-layout align-center>
          <!-- <small>ヘアカラー専門店</small> -->
          <v-img
            :src="`${$publicPath}img/fufu-logo-700.png`"
            max-width="100"
            max-height="24"
            contain
          />
        </v-layout>
      </v-flex>
      <v-flex xs8 class="text-center">
        <v-toolbar-title>
          <b><slot /></b>
        </v-toolbar-title>
      </v-flex>
      <v-flex xs2 class="text-end primary--text">
        {{ shop && shop.name }}
      </v-flex>
    </v-layout>
  </v-app-bar>
</template>

<script>
export default {
  name: 'FufuHeader',
  props: {
    shop: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style></style>
